// Constants
import { AnyAction } from 'redux';
import { USER_NAVIGATE } from '../../../../../common/users/userConstants';

const boardSearchPopupStayActivePredicate = (state: unknown, action: AnyAction): boolean => {
    switch (action.type) {
        case '@@router/LOCATION_CHANGE':
        case USER_NAVIGATE:
            return true;
        default:
            return false;
    }
};

export default boardSearchPopupStayActivePredicate;
